<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="content-modal-container">
                <div class="modal-header">
					<div class="modal-title">
						Создать папку
					</div>

					<div class="modal-header__close-button" @click="closeModal">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M18 6L6 18M6 6L18 18" stroke="#A8A8A8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</div>
                </div>
                <div class="modal-body">
                    <div class="mb-4">
                        <label for="name" class="form-label">Название папки <span class="color-red">*</span></label>
                        <input v-model="directoryName" type="text" name="name" class="form-control">
                    </div>

                    <div class="mb-4">
                        <div class="form-label">Клиент <span class="color-red">*</span></div>
                        <v-select
                            v-model="client"
                            :items="clients"
                            item-title="name"
                            return-object
                            variant="outlined"
                            color="primary"
                            density="compact"
                            clearable
                            @update:menu="$removeFocus"
                            @click:clear="handleClear"
                            @click:control="$removeFocus">
                            <template #no-data>
                                <v-list-item>
                                    <span>Данные не найдены</span>
                                </v-list-item>
                            </template>
                        </v-select>
                    </div>

                    <div>
                        <div class="form-label">Бренд <span class="color-red">*</span></div>
                        <v-select
                            :disabled="client ? false : true"
                            v-model="brand"
                            :items="brands"
                            item-title="name"
                            return-object
                            variant="outlined"
                            color="primary"
                            density="compact"
                            clearable
                            @update:menu="$removeFocus"
                            @click:clear="$removeFocus"
                            @click:control="$removeFocus">
                            <template #no-data>
                                <v-list-item>
                                    <span>Данные не найдены</span>
                                </v-list-item>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="modal-footer">
                    <ConfirmBtn :class="'btn btn-md btn-primary me-2'" :text="'Сохранить'" @btnClick="addDir"/>
                    <button class="btn btn-md btn-outline-dark" type="button" @click="closeModal">
                        <span>Отменить</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ConfirmBtn from '../elements/ConfirmBtn.vue';
    import Content from '../models/Content';
    import {handleError} from "vue";
    export default {
        name: 'FolderCreateModal',

        components: { ConfirmBtn },

        props: {
            clients: {
                type: Array,
                required: true
            },
            route_brand_search: String,
        },

        data() {
            return {
                content: new Content({
                    route_list: this.route_list,
                    route_delete: this.route_delete,
                    route_get: this.route_get,
                    route_create_dir: this.route_create_dir,
                    route_client_search: this.route_client_search,
                    route_brand_search: this.route_brand_search,
                    route_content_to_dir: this.route_content_to_dir,
                    route_dir_to_dir: this.route_dir_to_dir,
                    route_dir_content: this.route_dir_content,
                    route_dir_edit: this.route_dir_edit,
                    route_dir_del: this.route_dir_del,
                    route_content_upload: this.route_content_upload,
                    route_update: this.route_update,
                }),

                directoryName: '',
                client: null,
                brand: null,
                brands: []
            }
        },

        emits: [ "closeFolderCreateModal", "saveFolderCreateModal" ],

        methods: {
            handleError,
            closeModal: function() {
                this.$emit('closeFolderCreateModal');
            },

            searchBrands: async function () {
                let brands = await this.content.brands({
                    client_id: this.client.id
                });
                this.brands = brands.items;
            },

            addDir() {
                this.$emit('saveFolderCreateModal',
                    {
                        directoryName: this.directoryName,
                        client: this.client,
                        brand: this.brand
                    }
                );
            },
            handleClear(){
                this.client = null;
                this.brand = null;
                this.$removeFocus(false);
            }
        },

        watch: {
            client: {
                handler(newVal) {
                    if (newVal) this.searchBrands();
                }
            }
        },
    }

</script>

<style scoped lang="scss">

</style>
